import React, {useState} from "react";

function BackgroundFileSearch({onSearch, onCreate}) {
    const [name, setName] = useState("");

    const handleSearch = (e) => {
        e.preventDefault();
        onSearch(name);
    };

    return (
        <div className="search-container">
            <form onSubmit={handleSearch}>
                <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Search by name"
                />
                <button type="submit">Search</button>
            </form>
            <button onClick={onCreate}>Create New Background File</button>
        </div>
    );
}

export default BackgroundFileSearch;
